import get from 'lodash/get';
import { getRequestData } from '@/utils';
import { qryOrgBindSubsServiceTypeSummary, qryOrgBindSubsList, exportOrgBindSubsList, exportOrgAllBindSubsList, qryConfigParams, qryStatusAndExchangeCode } from '@/pages/CustomerAccount/services';

const defaultPageInfo = {
  pageIndex: 1,
  pageCount: 10,
};
export default {
  namespace: 'customerAccount',
  state: {
    total: 0,
    serviceTypeList: [],
    bindSubsList: [],
    pageInfo: defaultPageInfo,
    configParams: [],
    statusList: [],
    exchangeCodeList: [],
  },
  effects: {
    *qryOrgBindSubsServiceTypeSummary({ payload }, { call, put }) {
      const response = yield call(qryOrgBindSubsServiceTypeSummary, payload);
      const result = getRequestData(response);
      yield put({
        type: 'save',
        payload: {
          serviceTypeList: get(result, 'serviceTypeTotalDtoList') || [],
        },
      });
    },
    *qryOrgBindSubsList({ payload }, { call, put, select }) {
      const pageInfo = yield select(state => state.assignMembersArea.pageInfo);
      const response = yield call(qryOrgBindSubsList, payload);
      const { orgSubsBindRelaDtoList, pageDto = {} } = getRequestData(response);
      if (pageDto.pageIndex === 1) { // 只有第一页返回的总数才是真正的总数
        yield put({
          type: 'save',
          payload: {
            total: pageDto.totalRecord || 0,
          },
        });
      }
      yield put({
        type: 'save',
        payload: {
          bindSubsList: orgSubsBindRelaDtoList || [],
          pageInfo: {
            ...pageInfo,
            ...pageDto,
          },
        },
      });
    },
    *exportOrgBindSubsList({ payload }, { call }) {
      const response = yield call(exportOrgBindSubsList, payload) || {};
      const { data, success } = response;
      if (!success) {
        return;
      }
      const blob = new Blob([data], { type: 'application/octet-stream' });
      // 创建新的URL并指向File对象或者Blob对象的地址
      const blobURL = window.URL.createObjectURL(blob);
      // 创建a标签，用于跳转至下载链接
      const tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobURL;
      const docName = `${Date.parse(new Date())}.xlsx`;
      tempLink.setAttribute('download', decodeURI(docName));
      // 兼容：某些浏览器不支持HTML5的download属性
      if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank');
      }
      // 挂载a标签
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      // 释放blob URL地址
      window.URL.revokeObjectURL(blobURL);
    },
    *exportOrgAllBindSubsList({ payload }, { call }) {
      const response = yield call(exportOrgAllBindSubsList, payload) || {};
      const { data, success } = response;
      if (!success) {
        return;
      }
      const blob = new Blob([data], { type: 'application/octet-stream' });
      // 创建新的URL并指向File对象或者Blob对象的地址
      const blobURL = window.URL.createObjectURL(blob);
      // 创建a标签，用于跳转至下载链接
      const tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobURL;
      const docName = `${Date.parse(new Date())}.xlsx`;
      tempLink.setAttribute('download', decodeURI(docName));
      // 兼容：某些浏览器不支持HTML5的download属性
      if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank');
      }
      // 挂载a标签
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      // 释放blob URL地址
      window.URL.revokeObjectURL(blobURL);
    },
    *qryConfigParams({ payload }, { call, put }) {
      const response = yield call(qryConfigParams, payload);
      const paramsList = getRequestData(response);
      let paramsObj = {};
      if (paramsList != null && paramsList.length > 0) {
        paramsObj = JSON.parse(paramsList[0].paramValue);
      }

      yield put({
        type: 'save',
        payload: { configParams: paramsObj },
      });
    },
    *qryStatusAndExchangeCode({ payload }, { call, put }) {
      const response = yield call(qryStatusAndExchangeCode, payload);
      const paramsList = getRequestData(response);

      yield put({
        type: 'save',
        payload: {
          statusList: get(paramsList, 'subscriberStatusList') || [],
          exchangeCodeList: get(paramsList, 'subscriberExchangeCodeList') || [],
        },
      });
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    initPage(state) {
      return {
        ...state,
        pageInfo: defaultPageInfo,
      };
    },
  },
};
